var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallsmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#00B885"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#F0F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_72269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.18525 6.38653L7.32472 6.29213C8.10305 5.7928 9.13325 5.96827 9.73152 6.70167L10.5504 7.70933C11.0587 8.33467 11.1307 9.21646 10.7213 9.9048L10.0509 11.043C9.94298 11.2229 10.2623 11.7943 11.0587 12.5995C11.8639 13.3959 12.4354 13.7152 12.6198 13.6119L13.7535 12.9369C14.4463 12.5321 15.3236 12.5995 15.9534 13.1123L16.9611 13.9312C17.6944 14.5295 17.8699 15.5598 17.366 16.3335L17.276 16.4776C16.5923 17.5393 15.3191 18.1735 14.037 17.9443C12.3768 17.6427 10.6583 16.5901 8.85885 14.7996C7.07278 13.0045 6.01558 11.2815 5.71865 9.62593C5.48925 8.34373 6.12352 7.07047 7.18525 6.38653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3472 6.0142C15.1659 5.9814 14.9926 6.10193 14.96 6.2832C14.9272 6.46427 15.0477 6.6376 15.229 6.6704C16.5116 6.89447 17.5656 8.107 17.6551 9.41093C17.6623 9.51193 17.6643 9.61313 17.6603 9.71427C17.6529 9.89827 17.7962 10.0533 17.9803 10.0605C18.1642 10.0678 18.3193 9.92467 18.3266 9.74067C18.3315 9.61367 18.3291 9.4872 18.3198 9.3624C18.1959 7.7462 16.9571 6.31173 15.3472 6.0142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8758 7.4674C14.6946 7.4348 14.5212 7.55513 14.4887 7.7364C14.4561 7.91767 14.5765 8.091 14.7578 8.1236C15.484 8.247 16.0972 8.9506 16.1456 9.693L16.1486 9.8658C16.1414 10.0497 16.2848 10.2046 16.4689 10.2117C16.6528 10.2189 16.8077 10.0755 16.8149 9.8916C16.8179 9.8088 16.8164 9.7262 16.8104 9.64453C16.7275 8.5898 15.9295 7.66427 14.8758 7.4674Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_72269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallsmall);
export default __webpack_public_path__ + "static/media/callsmall.da9d5bcbdadd2a977020dcfce73f8cc7.svg";
export { ForwardRef as ReactComponent };